import { render, staticRenderFns } from "./field-area.html?vue&type=template&id=15c228da&"
import script from "./field-area.vue?vue&type=script&lang=js&"
export * from "./field-area.vue?vue&type=script&lang=js&"
import style0 from "./field-area.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports